import styled from 'styled-components';

export const Container = styled.form`
  display: flex;
  flex-direction: column;

  label {
    margin-top: 18px;
  }

  button {
    margin-top: 28px;
    align-self: flex-end;
  }
`;
